import { useMemo } from "react";

import { EntityTypesSupportedByIntegrations } from "@mapmycustomers/shared/types/entity";

import Integration from "@app/types/integrations/Integration";

const useSyncedEntityTypes = (
  currentIntegration?: Integration,
  supportedEntityTypes?: EntityTypesSupportedByIntegrations[]
) =>
  useMemo(
    () =>
      currentIntegration?.syncOptions && supportedEntityTypes
        ? (Object.keys(currentIntegration.syncOptions) as EntityTypesSupportedByIntegrations[])
            .filter(
              (entityType) =>
                (currentIntegration.syncOptions[entityType].incoming ||
                  currentIntegration.syncOptions[entityType].outgoing) &&
                supportedEntityTypes.includes(entityType)
            )
            .sort()
        : [],
    [currentIntegration, supportedEntityTypes]
  );

export default useSyncedEntityTypes;
